// Markdown preview plugin. See ../README.md for the plugin API.
import MarkdownPreview from './MarkdownPreview.vue'

export default {
  id: 'markdown',
  label: 'Rendered markdown',
  component: MarkdownPreview,

  matches({ file, content }) {
    // File-level name check: anything ending .md renders as markdown.
    if (file.name.toLowerCase().endsWith('.md')) return true
    // Some peek responses carry a MIME-ish data_type on the content
    // payload (distinct from the WorkflowFile.data_type choice field,
    // which is MAIN / SECONDARY / CONFIG — not a MIME type).
    if (
      content &&
      typeof content === 'object' &&
      content.data_type === 'text/markdown'
    ) {
      return true
    }
    return false
  },

  // Long READMEs exist but aren't infinite — 500k keeps the fetch
  // modest while still showing the whole document in practice.
  peekParams() {
    return { n: 500000 }
  },
}
